<template>
  <v-app>
    <v-row>
      <v-col lg="6">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          solo
          rounded
          clearable
          label="Search"
          single-line
          hide-details
          class="shrink w-100"
          @keyup.enter="onSearch"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-divider class="mt-4 mb-4"></v-divider>

    <v-data-iterator
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [50, 100, 150, 200, -1],
      }"
      :search="search"
    >
      <template v-slot:no-data>
        <p class="text-center">Pas de données</p>
      </template>
      <template v-slot:no-results>
        <p class="text-center">Pas de données</p>
      </template>
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="d-flex justify-content-center"
          >
            <div class="card p-3 bg-white flex-fill">
              <div class="custom-control custom-checkbox mt-n3">
                <label>
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="rowsSelected"
                    @click.stop
                    :value="item.id"
                  />
                  <span class="custom-control-label"></span>
                </label>
              </div>
              <div class="text-center mt-2">
                <div
                  class="col-12 d-flex align-items-center justify-content-center"
                >
                  <img
                    v-if="item.url_image"
                    :src="item.url_image"
                    style="width: 90%; height: 90%"
                  />
                  <img
                    v-else
                    :src="URL_LOCAL_FILE + '/images/no-image.png'"
                    style="width: 90%; height: 90%"
                  />
                </div>
                <div class="mt-3">
                  <h6>{{ item.designation }}</h6>
                </div>
              </div>
              <div class="mt-2">
                <div class="d-flex justify-content-between p-price mb-1">
                  <span>Référence </span><span>{{ item.reference }}</span>
                </div>
                <div
                  class="d-flex justify-content-between p-price mb-1"
                  v-if="item.fournisseur"
                >
                  <span>Fournisseur </span><span>{{ item.fournisseur }}</span>
                </div>
                <div class="d-flex justify-content-between p-price mb-1">
                  <span>Type </span><span>{{ item.article_type }}</span>
                </div>

                <div
                  class="d-flex justify-content-between total font-weight-bold mt-2"
                >
                  <span>Achat ? </span
                  ><span>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="item.achat"
                      class="p-2"
                    >
                      Oui
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Non
                    </b-badge>
                  </span>
                </div>
                <div
                  class="d-flex justify-content-between total font-weight-bold mt-2"
                >
                  <span>Vente ? </span
                  ><span>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="item.vente"
                      class="p-2"
                    >
                      Oui
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Non
                    </b-badge>
                  </span>
                </div>
                <div
                  class="d-flex justify-content-between total font-weight-bold mt-2"
                >
                  <span>Lot ? </span
                  ><span>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="item.lot"
                      class="p-2"
                    >
                      Oui
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Non
                    </b-badge>
                  </span>
                </div>
                <div class="d-flex justify-content-center mt-2">
                  <router-link
                    title="Cloner"
                    :to="{
                      name: 'gpao_article-create',
                      params: { cloneId: item.id },
                    }"
                    class="mr-4"
                  >
                    <i class="fa fa-clone text-secondary font-size-17"></i>
                  </router-link>

                  <router-link
                    title="Aperçu"
                    :to="{
                      name: 'gpao_article-show',
                      params: { id: item.id },
                    }"
                    class="mr-4"
                  >
                    <i class="fa fa-eye text-custom-primary font-size-17"></i>
                  </router-link>
                  <router-link
                    title="Modifier"
                    :to="{
                      name: 'gpao_article-edit',
                      params: { id: item.id },
                    }"
                  >
                    <i class="fa fa-edit text-secondary mr-4 font-size-17"></i>
                  </router-link>

                  <a
                    title="Supprimer"
                    class="cursor-pointer"
                    @click.prevent="deleteRow(item.id)"
                  >
                    <i class="fa fa-trash font-size-17 text-danger"></i
                  ></a>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-app>
</template>
<script>
import URL_A from '@/http/article_stock/article';
import URL_C from '@/http/achat/catalogue';
import config from '@/config';
export default {
  data() {
    return {
      selectedArticles: [],
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      items: [],
      total: 0,
      options: {
        itemsPerPage: 100,
      },
      search: '',
      filterTypes: [],
      filterTiers: [],
      rowsSelected: [],
      idsRowsSelected: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.loadItems();
      },
      deep: true,
    },
    rowsSelected(vals) {
      this.$emit('onSelect', false);
      this.idsRowsSelected = vals;
      this.$emit('onSelect', this.idsRowsSelected.length > 0);
    },
  },
  computed: {
    currentUrl() {
      if (this.filterTiers.length > 0) return URL_C.TIERS_CATALOGUE;
      return URL_A.ARTICLE;
    },
  },
  methods: {
    setFilter(filterTypes, filterTiers) {
      this.filterTypes = filterTypes;
      this.filterTiers = filterTiers;
    },
    showRow(id) {
      this.$emit('onRowShow', id);
    },
    editRow(id) {
      this.$emit('onRowEdit', id);
    },
    deleteRow(id) {
      this.$emit('onRowsDelete', [id]);
    },
    onSearch() {
      this.loadItems();
    },
    loadItems() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      //this.idsRowsSelected = [];
      //this.rowsSelected = [];
      window.axios
        .get(this.currentUrl, {
          params: {
            search: this.search,
            sortBy: sortBy.length > 0 ? sortBy[0] : 'id',
            sortDesc: sortDesc.length > 0 ? sortDesc[0] : true,
            page: page,
            perPage: itemsPerPage,
            articletypes: this.filterTypes,
            allTiers: this.filterTiers,
          },
        })
        .then((resp) => {
          this.items = resp.data.data;
          this.total =
            itemsPerPage === -1 ? resp.data.length : resp.data.meta.total;
        })
        .catch();
    },
  },
  mounted() {
    this.rowsSelected = [];
    this.idsRowsSelected = [];
    this.loadItems();
  },
};
</script>
